const LOG_FLUSH_TIMEOUT_MS = 2000;

export const claimErrorReload = (digest?: string) => {
  const key = `error-reloaded:${globalThis.location.pathname}:${digest ?? 'unknown'}`;

  try {
    if (globalThis.sessionStorage.getItem(key) !== null) return false;
    globalThis.sessionStorage.setItem(key, '1');
    return true;
  } catch {
    return false;
  }
};

export const reloadAfterLogging = (logged: Promise<unknown>) => {
  const reload = () => globalThis.location.reload();
  const flushed = new Promise((resolve) => setTimeout(resolve, LOG_FLUSH_TIMEOUT_MS));

  Promise.race([logged, flushed]).then(reload, reload);
};
